export default "__VITE_ASSET__Bwez6tUt__"